// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1IeQf","title":"Header_title__1pbXY","side":"Header_side__1aUPZ"};